import { merge } from "glamor";
import * as React from "react";
import {
    cancelAnimationTimeout,
    requestAnimationTimeout,
} from "react-virtualized/dist/commonjs/utils/requestAnimationTimeout";
import { IContainerHOCProps, IContainerHOCState } from "../infinite-interface";
import { SCROLLING_RESET_TIME_INTERVAL, SCROLL_DIRECTION } from "constants/scroll";

export class ContainerHOC extends React.PureComponent<IContainerHOCProps, IContainerHOCState> {
    private styles = merge({
        position: "relative",
        overflow: "auto",
        contain: "layout",
        userSelect: "none",
    });

    private disablePointerEventsTimeoutId;

    constructor(props) {
        super(props);

        this.state = {
            scrollTop: 0,
            isScrolling: false,
            scrollDirectionVertical: SCROLL_DIRECTION.FORWARD,
            style: {
                height: props.containerHeight,
                width: props.containerWidth,
            },
        } as any;
    }

    UNSAFE_componentWillMount() {
        this.props.api.on("scrollTo", this.handleScrollTo);
    }

    componentWillUnmount() {
        this.props.api.off("scrollTo", this.handleScrollTo);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.width !== this.props.containerWidth || nextProps.height !== this.props.containerHeight) {
            this.setState({
                style: {
                    height: nextProps.containerHeight,
                    width: nextProps.containerWidth,
                },
            });
        }
    }

    render() {
        const { children } = this.props;
        const { style } = this.state;
        return (
            <div
                role="grid"
                aria-label="grid"
                aria-readonly="false"
                {...this.styles}
                style={style}
                onScroll={this.handleScroll}
                ref={this.setScrollingContainerRef}
            >
                {children({ ...this.state })}
            </div>
        );
    }

    private setScrollingContainerRef = (ref) => this.setState({ scrollingContainer: ref });

    private handleScroll = () => {
        if (!this.state.scrollingContainer) {
            return;
        }

        const { scrollTop = 0 } = this.state.scrollingContainer;

        this.debounceScrollEnded();

        if (this.state.scrollTop !== scrollTop) {
            const scrollDirectionVertical =
                scrollTop !== this.state.scrollTop
                    ? scrollTop > this.state.scrollTop
                        ? SCROLL_DIRECTION.FORWARD
                        : SCROLL_DIRECTION.BACKWARD
                    : this.state.scrollDirectionVertical;

            this.setState({
                scrollTop,
                isScrolling: true,
                scrollDirectionVertical,
            });
        }
    };

    private handleScrollTo = () => {
        if (!this.state.scrollingContainer) {
            return;
        }
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.scrollingContainer.scrollTop = 0;
        this.setState({
            scrollTop: 0,
        });
    };

    private debounceScrollEnded() {
        if (this.disablePointerEventsTimeoutId) {
            cancelAnimationTimeout(this.disablePointerEventsTimeoutId);
        }

        this.disablePointerEventsTimeoutId = requestAnimationTimeout(
            this.handleDebounceScrollEndedCallback,
            SCROLLING_RESET_TIME_INTERVAL
        );
    }

    private handleDebounceScrollEndedCallback = () => {
        this.disablePointerEventsTimeoutId = null;
        this.setState({
            isScrolling: false,
        });
    };
}
